import { useEffect, useState } from "react";
import axios from "axios";

import { useLoaderContext } from "../../../components/Loader/LoaderContext";

interface DictionaryItem {
  id?: number;
  code?: string;
  name?: string;
  value?: string;
  [key: string]: any;
}

const TestPage = () => {
  const { hideLoader } = useLoaderContext();

  const [data, setData] = useState<DictionaryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDictionary();
  }, []);

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => {
        hideLoader();
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [loading, hideLoader]);

  const fetchDictionary = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        "https://workvista-devapi.sagility.com/v1/master-dictionary/get-all"
      );

      console.log("API Response:", response.data);

      setData(
        Array.isArray(response.data)
          ? response.data
          : response.data?.data ?? []
      );
    } catch (err: any) {
      console.error(err);
      setError(err.message || "API Failed");
    } finally {
      setLoading(false);
    }
  };

  // Let the global loader handle loading UI
  if (loading) {
    return null;
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen text-red-600">
        {error}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">
          Master Dictionary Test
        </h1>

        <div className="bg-white rounded-lg shadow overflow-auto">
          <table className="w-full">
            <thead className="bg-indigo-600 text-white">
              <tr>
                {data.length > 0 &&
                  Object.keys(data[0]).map((key) => (
                    <th
                      key={key}
                      className="px-4 py-3 text-left"
                    >
                      {key}
                    </th>
                  ))}
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr
                  key={index}
                  className="border-b hover:bg-gray-50"
                >
                  {Object.keys(item).map((key) => (
                    <td
                      key={key}
                      className="px-4 py-3 text-sm"
                    >
                      {String(item[key])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TestPage;